import React, { useEffect, useState, useRef } from "react";

import CSUtil from "../util/CSUtil";
import CSServiceUtil from "../util/CSServiceUtil";
import CSRequestUtil from "../util/CSRequestUtil";
import { cfGetConstantValue } from "../util/CSConstantUtil";

import { Carousel } from "primereact/carousel";
import "primeflex/primeflex.css";
import { Height } from "@mui/icons-material";

const CSCarousel = (gProps) => {
    const serviceUtilRef = useRef(CSServiceUtil.cfGetInstance());

    const [numScrollableItems, setNumScrollableItems] = useState(3);
    const [numItemsVisible, setNumItemsVisible] = useState(4);
    const [itemTitle, setItemTitle] = useState(null);
    const [itemDetail1, setItemDetail1] = useState(null);
    const [itemDetail2, setItemDetail2] = useState(null);
    const [itemSummary, setItemSummary] = useState(null);
    const [widgetTemplate, setWidgetTemplate] = useState(null);
    const [reportName, setReportName] = useState(null);
    const [mServiceCode, setServiceCode] = useState(null);
    const [mDataCollection, setDataCollection] = useState([]);

    useEffect(() => {
        if (gProps.pWidgetList && gProps.pWidgetList.length > 0) {
            const widgetReport = gProps.pWidgetList[0];
            if (widgetReport) {
                setWidgetTemplate(widgetReport.layout_code_ || "CS_DEFAULT_WIDGET_TEMPLATE");
                setServiceCode(widgetReport.service_code_ || null);
                setReportName(widgetReport.report_name_ || null);

                if (Array.isArray(widgetReport.report_properties_)) {
                    widgetReport.report_properties_.forEach((prop) => {
                        switch (prop.property_) {
                            case "num_scrollable_items_":
                                setNumScrollableItems(Number(prop.value_));
                                break;

                            case "num_items_visible_":
                                setNumItemsVisible(Number(prop.value_));
                                break;

                            case "item_title_":
                                setItemTitle(prop.value_);
                                break;

                            case "item_detail_1_":
                                setItemDetail1(prop.value_);
                                break;

                            case "item_detail_2_":
                                setItemDetail2(prop.value_);
                                break;

                            case "item_summary_":
                                setItemSummary(prop.value_);
                                break;

                            default:
                                break;
                        }
                    });
                }
            }
        } else {
            setWidgetTemplate((prev) => prev || "CS_DEFAULT_WIDGET_TEMPLATE");
        }
    }, [gProps.pWidgetList]);

    useEffect(() => {
        if (!mServiceCode) return;

        const serviceUtil = serviceUtilRef.current;
        const serviceObject = serviceUtil.cfGetServiceObject(mServiceCode);
        if (!serviceObject) return;

        const criteriaObj = {};

        if (Array.isArray(serviceObject.cs_service_properties_)) {
            serviceObject.cs_service_properties_.forEach((sp) => {
                criteriaObj[sp.property_] = cfGetConstantValue(sp.value_);
            });
        }

        const requestUtil = new CSRequestUtil(
            "GET",
            mServiceCode,
            serviceObject.type_,
            null,
            serviceObject
        );

        requestUtil.cfSetRequestCriteria(criteriaObj);
        requestUtil.cfProcessRequest((response) => {
            let collection = [];
            if (response && response.collection_) {
                if (Array.isArray(response.collection_)) {
                    collection = response.collection_;
                } else {
                    collection = [response.collection_];
                }
            }
            setDataCollection(collection);
        });
    }, [mServiceCode]);

    const renderTemplate = (item) => {
        if (!item) return null;

        if (widgetTemplate === "CS_DEFAULT_WIDGET_TEMPLATE") {
            return (
                <div style={styCardStyle}>
                    <span style={styTitle}>
                        {itemTitle ? item[itemTitle] : ""}
                    </span>

                    <span style={styDetail1}>
                        {itemDetail1 ? item[itemDetail1] : ""}
                    </span>

                    <span style={styDetail2}>
                        {itemDetail2 ? item[itemDetail2] : ""}
                    </span>

                    <span style={stySummaryItem}>
                        {itemSummary ? item[itemSummary] : ""}
                    </span>
                </div>
            );
        }

        // placeholder for future custom templates
        return null;
    };

    const carouselKey = `${numItemsVisible}-${numScrollableItems}-${mDataCollection.length}`;
    return (
        <div className="carousel-form"
            style={{
                padding: "10px 0",
                justifyContent: "center",
            }}>
            <Carousel
                key={carouselKey}
                value={mDataCollection}
                itemTemplate={renderTemplate}
                numVisible={numItemsVisible}
                numScroll={numScrollableItems}
                circular
            />
        </div>
    );
};

const styCarouselCard = {
    backgroundColor: "rgba(204, 225, 242, 0.55)",
    padding        : "0.9em",
    borderRadius   : "8px",
    minWidth       : "175px",
    maxWidth       : "320px",
    marginTop      : "5px",
    marginLeft     : "12px",
    marginRight    : "12px",
    flex           : "0 0 auto",
    display        : "flex",
    flexDirection  : "column",
    justifyContent : "space-between",
    minHeight      : "100px",
    boxSizing      : "border-box",
};

const stySummary = {
    position: "relative",
};

const styTitle = {
    fontSize: "16px",
    fontWeight: "500",
};

const styDetail1 = {
    color     : "#707070",
    display   : "block",
    marginTop : "8px",
    fontSize  : "12px",
};

const styDetail2 = {
    color     : "#707070",
    display   : "block",
    marginTop : "8px",
    fontSize  : "12px",
};

const stySummaryItem = {
    backgroundColor: "#20d077",
    color          : "#fff",
    position       : "absolute",
    top            : "15px",
    bottom         : "15px",
    right          : "15px",
    fontSize       : "14px",
    padding        : "8px 10px",
    borderRadius   : "3px",
    float          : "right",
};

const styCardStyle = Object.assign({}, styCarouselCard, stySummary);

export default CSCarousel;
